import 'brace/ext/language_tools';
import 'brace/mode/python';
import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';
import AceEditor from 'react-ace';

import {assert} from 'Asserts';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStep, pipelineStepIsStepType} from 'pipelines/PipelineTypes';

import {MAX_POPOVER_HEIGHT, MAX_POPOVER_WIDTH} from './PopoverConstants';

export default function UserDefinedFunctionPopoverContents({step}: {step: PipelineStep}): JSX.Element {
  assert(
    pipelineStepIsStepType(PipelineStepType.USER_DEFINED_FUNCTION, 0, step),
    'Expected USER_DEFINED_FUNCTION step'
  );
  assert(step.config != null, 'Expected non-null config');

  const code = typeof step.config.userDefinedCode === 'string' ? step.config.userDefinedCode : '';

  return (
    <div
      className={css(styles.wrapper)}
      {...getTestProps({component: 'UserDefinedFunctionPopoverContents', element: 'root'})}
    >
      <AceEditor
        value={code}
        mode="python"
        readOnly={true}
        showGutter={true}
        showPrintMargin={false}
        wrapEnabled={true}
        width={`${EDITOR_WIDTH}px`}
        height={`${EDITOR_HEIGHT}px`}
        highlightActiveLine={false}
        setOptions={{
          useWorker: false, // Disable syntax checking for performance in popover
          // @ts-expect-error - $blockScrolling is a valid Ace option not in types
          $blockScrolling: Infinity, // Suppress scrolling warning
        }}
      />
    </div>
  );
}

const PADDING = 10;
const EDITOR_WIDTH = MAX_POPOVER_WIDTH - PADDING * 2;
const EDITOR_HEIGHT = MAX_POPOVER_HEIGHT - PADDING * 2;

const styles = StyleSheet.create({
  wrapper: {
    padding: PADDING,
    margin: PADDING,
  },
});
